export function money(n) {
  const value = Number(n) || 0;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }).format(value);
}

export function formatDate(d) {
  if (!d) return '';
  return new Date(`${d}T00:00:00`).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

// Local calendar date as 'YYYY-MM-DD' -- deliberately NOT toISOString().slice(0,10),
// which reports the UTC date and can be a day off from the user's actual local
// "today" (e.g. late evening IST is still the next UTC day).
export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function thisMonthISO() {
  return todayISO().slice(0, 7);
}

// { first, last } of the calendar month for a given 'YYYY-MM-DD' (defaults to today).
export function monthBounds(dateStr) {
  const base = dateStr ? new Date(`${dateStr}T00:00:00`) : new Date();
  const y = base.getFullYear();
  const m = base.getMonth();
  const first = `${y}-${String(m + 1).padStart(2, '0')}-01`;
  const lastDay = new Date(y, m + 1, 0).getDate();
  const last = `${y}-${String(m + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
  return { first, last };
}
